import React, { Fragment } from "react";
import { Button } from "react-bootstrap";

import "./style.scss";

export const FavoriteButton = ({ addButton, fromProgramPage, handleClick, item, labels }) => {

  return (
    <Fragment>
      { addButton ? (
        <Button
          aria-label={labels.add_to_fav}
          className={`favorite-btn ${fromProgramPage ? "from-program-page" : ""}`}
          onClick={(e) => handleClick(e, true)}
          tabIndex="0"
          aria-haspopup="true"
        >
          <div className={`favorite-logo ${fromProgramPage ? "from-program-page" : ""} ${addButton ? "add-button" : ""}`}/>
          <span className={`btn-title ${fromProgramPage ? "from-program-page" : ""}`}>
            {labels.add_to_fav}
          </span>
        </Button>
      ) : (
        <Button
          aria-label={labels.remove_from_fav}
          className={`favorite-btn ${fromProgramPage ? "from-program-page" : ""}`}
          current-nid={item.nid}
          onClick={(e) => handleClick(item.nid, e)}
          tabIndex={0}
          aria-labelledby="removeText"
        >
          <div className={`favorite-logo ${fromProgramPage ? "from-program-page" : ""}`}/>
          <span 
          id="removeText" 
          className={`btn-title ${fromProgramPage ? "from-program-page" : ""}`}>
            { labels.remove_from_fav }
          </span>
        </Button>
      )}
    </Fragment>
  )
}